import React from 'react';
import ErrorPage from './ErrorPage';

const mockError = { status: 500, stack: 'stack trace' };

export default () => ({
  chunks: ['500'],

  component: <ErrorPage error={mockError} />,
  status: 500,
  title: 'Critical Error',
  accountWrapper: {
    loginRequired: false,
    nonBlocking: true,
  },
});

if (module.hot) {
  module.hot.accept();
}
